import type { PublicSlotKey } from '@/apilib';
import type { WorkspaceModesApi } from './workspaceModesApi';

export const WorkspaceModesApiKey: PublicSlotKey<WorkspaceModesApi> = {
  name: 'WorkspaceModesApi',
  public: true,
};
